import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import RequestPage from './Request';

import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router,Route, Switch } from 'react-router-dom'





const Routing= (
  <Router>
    <div>
      <Route exact path="/" component={App} />
      <Route path="/requestquote" component={RequestPage} />
    </div>
  </Router>
);

ReactDOM.render(Routing, document.getElementById('root'));
